import Cookies from "js-cookie";
import ReactPixel from "react-facebook-pixel";
import { store } from "utils/store/configureStore";
import { gaEvent } from "./trackEvents";

/**
 * @param  { String } utms
 * @return String
 */
// Keys that would mutate Object.prototype rather than the result object.
// A query string like "?__proto__[x]=y" is attacker-controlled input, so they
// are dropped instead of assigned.
const UNSAFE_UTM_KEYS = new Set(["__proto__", "constructor", "prototype"]);

export function formatUtm(utms) {
  // Collected in a Map first: a Map has no prototype chain, so an
  // attacker-supplied key cannot reach Object.prototype on the way in, and
  // there is no computed property write to inject into. Object.fromEntries
  // then defines own properties directly, which never invokes an inherited
  // setter of the same name.
  const collected = new Map();

  utms
    .split("?")[1]
    .split("&")
    .forEach(utm => {
      const splitedUtm = utm.split("=");
      const key = splitedUtm[0];
      const value = splitedUtm[1];
      if (!key || UNSAFE_UTM_KEYS.has(key)) return;
      collected.set(key, value);
    });

  return Object.fromEntries(collected);
}

/**
 * Solely based on cookies
 *
 * If we detect that the user has a UTM attributed, then we can fire an event.
 *
 * @param  {string} from
 * @param  {string} action
 * @param  {string} category
 * @returns {TrackEvent}
 */
export function trackAdsByCookie({ from, action, category }) {
  const spocketUtm = Cookies.get("spocket_utm") || "";
  const isThisValidUTM = utmName => spocketUtm.indexOf(utmName) > 0;

  switch (from.toLocaleLowerCase()) {
    case "facebook":
      if (isThisValidUTM("facebook_ads")) {
        ReactPixel.trackCustom(action);
      }
      break;

    case "google":
      if (isThisValidUTM("google") || isThisValidUTM("cpc")) {
        gaEvent({
          category,
          action
        });
      }
      break;

    default:
      return;
  }
}

/**
 * Triggers based on existing UTM data in Redux
 *
 * If we detect that the user has a UTM attributed, then we can fire an event.
 *
 * @param  {string} from
 * @param  {string} action
 * @param  {string} category
 * @returns {TrackEvent}
 */
export function trackAdsByRedux({ from, action, category, option }) {
  // Account info may not be loaded (or GET /store failed), so don't assume it's there
  const spocketUtm = store.getState().store?.information?.account?.utm || {};
  const { utm_source, utm_medium } = spocketUtm;

  switch (from.toLocaleLowerCase()) {
    case "facebook":
      if (utm_source === "facebook_ads") {
        ReactPixel.trackCustom(action, option);
      }
      break;

    case "google":
      if (utm_source === "google" || utm_medium === "cpc") {
        gaEvent({
          category,
          action
        });
      }
      break;

    default:
      return;
  }
}

// Private
